export { RangeComponent } from "./range-component";
export type { RangeComponentProps } from "./range-component";
